import {
  StyledDefaultBalance,
  StyledBalanceText,
  StyledBalanceImage,
} from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import { Balance } from 'components/Layouts/BalancesLayout/types';
import { useEffect, useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';

interface DefaultBalanceProps {
  balance: Balance;
  fontSize: string;
  playerName?: string;
  displayAmount?: string;
  fontWeight?: string
}

interface DefaultBalanceWithResizeProps {
  balance: Balance;
  playerName?: string;
  displayAmount?: string;
  setFontSize?: (size: string) => void;
  fontWeight?: string
}

export const DefaultBalance: React.FC<DefaultBalanceProps> = ({
  balance,
  playerName,
  displayAmount,
  fontSize,
  fontWeight
}) => {
  return (
    <StyledDefaultBalance playerName={playerName} fontWeight={fontWeight}>
      {balance.image && (
        <StyledBalanceImage
          className="balanceImg balance__img"
          alt="balance"
          src={balance.image}
        />
      )}
      {displayAmount && (
        <StyledBalanceText fontSize={fontSize}>
          {displayAmount}
        </StyledBalanceText>
      )}
    </StyledDefaultBalance>
  );
};

export const DefaultBalanceWithResize: React.FC<
  DefaultBalanceWithResizeProps
> = ({ balance, playerName, displayAmount, setFontSize, fontWeight }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const updateFontSize = () => {
      if (elementRef.current) {
        const computedStyle = window.getComputedStyle(elementRef.current);
        setFontSize?.(computedStyle.fontSize);
      }
    };

    const observer = new ResizeObserver(updateFontSize);

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      if (elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);

  return (
    <AutoTextSize
      as="span"
      mode="oneline"
      maxFontSizePx={14}
      minFontSizePx={10}
      id="firstDiv"
    >
      <StyledDefaultBalance playerName={playerName} fontWeight={fontWeight}>
        {balance.image && (
          <StyledBalanceImage
            className="balanceImg balance__img"
            alt="balance"
            src={balance.image}
          />
        )}
        {displayAmount && (
          <StyledBalanceText ref={elementRef}>
            {displayAmount}
          </StyledBalanceText>
        )}
      </StyledDefaultBalance>
    </AutoTextSize>
  );
};
